import loadable from '@loadable/component';

export const DayPickerInput = loadable(() => import('react-day-picker/DayPickerInput'));
export const DayPickerMomentLib = loadable.lib(() => import('react-day-picker/moment'));
